/*
    Add here your own custom javascript
*/
document.addEventListener("DOMContentLoaded", function() {
  const modelVariantsList = document.querySelector(".inner_model_variant .model_variants_list");
  if (!modelVariantsList) return;

  // 🔒 STOP when block.settings.first_model is false
  if (modelVariantsList.dataset.firstModel !== "true") return; 

  let imgEl = document.querySelector("#product-template.product-custom .main-splide .splide__slide.first_slide img");
  let imgElThumb = document.querySelector("#product-template.product-custom .thumbs-splide .splide__slide.first_slide img");

  if (imgEl && imgElThumb) {
    currentSrc = imgEl.src;
    currentthumbSrc = imgElThumb.src;

    imgEl.setAttribute("src", "https://cdn.shopify.com/s/files/1/0077/0352/7475/files/Cubby_Plus_-_lead_image_2.png?v=1759382538&width=1200&height=960&crop=center");
    imgElThumb.setAttribute("src", "https://cdn.shopify.com/s/files/1/0077/0352/7475/files/Cubby_Plus_-_lead_image_2.png?v=1759382538&width=160&height=160&crop=center");

    imgElThumb.click();
  }
});
var modelVariantsList_first = document.querySelector(".inner_model_variant .model_variants_list");
if(modelVariantsList_first){
modelVariantsList_first.addEventListener("click", function () {
  // 🔒 STOP on click too
    if (this.dataset.firstModel !== "true") return; 
let imgEl = document.querySelector("#product-template.product-custom .main-splide .splide__slide.first_slide img");
  let imgElThumb = document.querySelector("#product-template.product-custom .thumbs-splide .splide__slide.first_slide img");

  if (imgEl && imgElThumb) {
    currentSrc = imgEl.src;
    currentthumbSrc = imgElThumb.src;

    imgEl.setAttribute("src", "https://cdn.shopify.com/s/files/1/0077/0352/7475/files/Cubby_Plus_-_lead_image_2.png?v=1759382538&width=1200&height=960&crop=center");
    imgElThumb.setAttribute("src", "https://cdn.shopify.com/s/files/1/0077/0352/7475/files/Cubby_Plus_-_lead_image_2.png?v=1759382538&width=160&height=160&crop=center");

    imgElThumb.click();
  }
});
}


// Bed Only option (restore original image)
var modelVariantsList_1 = document.querySelector(".inner_model_variant .model_variants_list_light");
if(modelVariantsList_1){
modelVariantsList_1.addEventListener("click", function () {
    this.closest("#product-template.product-custom").querySelector(".main-splide .splide__slide.first_slide img").setAttribute("src", currentSrc);
    this.closest("#product-template.product-custom").querySelector(".thumbs-splide .splide__slide.first_slide img").setAttribute("src", currentthumbSrc);
  this.closest("#product-template.product-custom").querySelector(".thumbs-splide .splide__slide.first_slide img").click();
});
}
var modelVariantsList = document.querySelectorAll(".inner_model_variant .model_variants_list");

modelVariantsList.forEach(function (element) {
  element.addEventListener("click", function () {
    var selectedVal = this.getAttribute("data-varianttitle");
    var modelVariantsList = document.querySelectorAll(".inner_model_variant .model_variants_list");
    modelVariantsList.forEach(function (element) {
      element.classList.remove("active");
    });
    this.classList.add("active");
    var singleOptionSelector = document.querySelector('#product-option-model');
    singleOptionSelector.value = selectedVal;
    var event = new Event('change');
    singleOptionSelector.dispatchEvent(event);
  });
});

const elms = document.querySelectorAll(".model_variants_detail ul li strong");

elms.forEach((elm) => {
    elm.parentElement.classList.add('new-class');
});

document.querySelectorAll(".different_addtocart").forEach(function(element) {
  element.addEventListener("click", function(e) {
    e.preventDefault();
    this.style.display = "none";
    document.querySelector(".klaviyo_bottom_form").style.display = "block";
  });
});
let NeedBed = document.querySelector(".needs-bed");

if(NeedBed){
  let splide = new Splide( '.needs-bed', {
    direction: 'ttb',
    height   : '10rem',
    wheel    : true,
    pagination: false,
    arrows: false, 
});
  
splide.mount();
}


// Remove play icon if video has played
document.querySelectorAll('video').forEach(video => {
  video.addEventListener("play", (event) => { 
    if (video.nextElementSibling.classList.contains('video-play-icon')) {
      video.nextElementSibling.remove()
    }
  })
})

/**/
document.addEventListener('shopify:section:load', (e) => {
  const insuranceBlockStep = document.querySelectorAll('.insurance-steps .block_steps .block_step');  
insuranceBlockStep.forEach(item => {
   item.addEventListener("click", (event) => {
     const blockId = item.dataset.blockId;
     
     item.closest(".insurance-steps").querySelectorAll('.block_steps .block_step').forEach(step => {
       step.classList.remove('is_active');
     });
     item.classList.add('is_active');

     item.closest(".insurance-steps").querySelectorAll('.insurance-steps .insurance-block_step').forEach(item => {
       item.classList.remove('is_active');
     });
     item.closest(".insurance-steps").querySelector('#' + blockId).classList.add('is_active');

     item.closest(".insurance-steps").querySelectorAll('.insurance-steps .block__progress_bar_inner').forEach(item => {
       item.classList.remove('is_active');
     });
     item.closest(".insurance-steps").querySelector('.insurance-steps .block__progress_bar_inner[data-block-id="' + blockId +'"]').classList.add('is_active');    

     item.closest(".insurance-steps").querySelector('.insurance-block_steps_wrapper').style.maxHeight = item.closest(".insurance-steps").querySelector('.insurance-block_steps_wrapper').scrollHeight + 'px';
   });
});
});


const insuranceBlockStep = document.querySelectorAll('.insurance-steps .block_steps .block_step');  
insuranceBlockStep.forEach(item => {
   item.addEventListener("click", (event) => {
    
     const blockId = item.dataset.blockId;
     
     item.closest(".insurance-steps").querySelectorAll('.block_steps .block_step').forEach(step => {
       step.classList.remove('is_active');
     });
     item.classList.add('is_active');

     item.closest(".insurance-steps").querySelectorAll('.insurance-steps .insurance-block_step').forEach(item => {
       item.classList.remove('is_active');
     });
     item.closest(".insurance-steps").querySelector('#' + blockId).classList.add('is_active');

     item.closest(".insurance-steps").querySelectorAll('.insurance-steps .block__progress_bar_inner').forEach(item => {
       item.classList.remove('is_active');
     });
     item.closest(".insurance-steps").querySelector('.insurance-steps .block__progress_bar_inner[data-block-id="' + blockId +'"]').classList.add('is_active');    

     item.closest(".insurance-steps").querySelector('.insurance-block_steps_wrapper').style.maxHeight = item.closest(".insurance-steps").querySelector('.insurance-block_steps_wrapper').scrollHeight + 'px';
   });
});

/**/
let navbar = document.querySelector(".navbar_wrapper");
let lastScrollTop = 0;

if(navbar){
let navbarStyle = navbar.getAttribute("data-navbar-style");

if (navbarStyle === "sticky") {
    window.addEventListener("scroll", function () {
        if (window.scrollY > 50) {
            navbar.style.position = "fixed";
            navbar.style.top = "10px";
        } else {
            navbar.style.position = "absolute";
            navbar.style.top = "50px";
        }
    });
} else if (navbarStyle === "show_on_scroll") {
    window.addEventListener("scroll", function () {
        let currentScroll = window.scrollY;

        if (currentScroll > lastScrollTop) {
          navbar.style.position = "absolute";
          navbar.style.top = "50px";
        } else {
            navbar.style.position = "fixed";
            navbar.style.top = "10px";
        }

       if (currentScroll === 0) {
                   navbar.style.position = "absolute";
          navbar.style.top = "50px";
       }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });
}
}

document.addEventListener('shopify:section:load', (e) => {
  let navbar = document.querySelector(".navbar_wrapper");
let lastScrollTop = 0;

if(navbar){
let navbarStyle = navbar.getAttribute("data-navbar-style");

if (navbarStyle === "sticky") {
    window.addEventListener("scroll", function () {
        if (window.scrollY > 50) {
            navbar.style.position = "fixed";
            navbar.style.top = "10px";
        } else {
            navbar.style.position = "absolute";
            navbar.style.top = "50px";
        }
    });
} else if (navbarStyle === "show_on_scroll") {
    window.addEventListener("scroll", function () {
        let currentScroll = window.scrollY;

        if (currentScroll > lastScrollTop) {
          navbar.style.position = "absolute";
          navbar.style.top = "50px";
        } else {
            navbar.style.position = "fixed";
            navbar.style.top = "10px";
        }

       if (currentScroll === 0) {
                   navbar.style.position = "absolute";
          navbar.style.top = "50px";
       }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });
}
}
});